import Vue from 'vue'
import Router from 'vue-router'
import Store from '../store'

import Login from '@/pages/login'
import Member from '@/pages/member'
import Message from '@/pages/member/message'
import Feedback from '@/pages/member/feedback'
import Course from '@/pages/member/course'
import Live from '@/pages/member/live'
import Question from '@/pages/member/question'
import Collect from '@/pages/member/collect'
import Study from '@/pages/study'
import Liveroom from '@/pages/liveroom'
import Liveback from '@/pages/liveback'
import Liveroom2 from '@/pages/liveroom2'
import Paper from '@/pages/paper'
import WrongBook from '@/pages/exercise/WrongBook'
import FavExercise from '@/pages/exercise/FavExercise'
import CourseWare from '@/pages/exercise/CourseWare'
import CourseYati from '@/pages/exercise/CourseYati'

Vue.use(Router)


const routerPush = Router.prototype.push
Router.prototype.push = function push (location) {
  return routerPush.call(this, location).catch(err => err)
}


const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Member',
      meta: {
        title: "个人中心",
        requireAuth: true
      },
      component: Member,
      children: [
        {
          path: '',
          name: 'Course',
          meta: {
            title: "课程列表",
            requireAuth: true
          },
          component: Course
        },
        {
          path: 'live',
          name: 'Live',
          meta: {
            title: "我的直播",
            requireAuth: true
          },
          component: Live
        },
        {
          path: 'question',
          name: 'Question',
          meta: {
            title: "题库列表",
            requireAuth: true
          },
          component: Question
        },
        {
          path: 'collect',
          name: 'Collect',
          meta: {
            title: "题目收藏",
            requireAuth: true
          },
          component: Collect
        },
        {
          path: 'message',
          name: 'Message',
          meta: {
            title: "消息中心",
            requireAuth: true
          },
          component: Message
        },
        {
          path: 'feedback',
          name: 'Feedback',
          meta: {
            title: "我要反馈",
            requireAuth: true
          },
          component: Feedback
        },
      ]
    },
    {
      path: '/login',
      name: 'Login',
      meta: {
        title: "登陆"
      },
      component: Login
    },
    {
      path: '/study/:cid',
      name: 'Study',
      meta: {
        title: "课程",
        requireAuth: true
      },
      component: Study
    },
    {
      path: '/liveroom/:lid',
      name: 'Liveroom',
      meta: {
        title: "直播",
        requireAuth: true
      },
      component: Liveroom
    },
    {
      path: '/liveback/:lid',
      name: 'Liveback',
      meta: {
        title: "直播回放",
        requireAuth: true
      },
      component: Liveback
    },
    {
      path: '/liveroom2/:lid',
      name: 'Liveroom2',
      meta: {
        title: "直播",
        requireAuth: true
      },
      component: Liveroom2
    },
    {
      path: '/paper/:id',
      name: 'Paper',
      meta: {
        title: "试卷",
        requireAuth: true
      },
      component: Paper
    },
    {
      path: '/exercise/WrongBook/:sid',
      name: 'WrongBook',
      meta: {
        title: "错题本",
        requireAuth: true
      },
      component: WrongBook
    },
    {
      path: '/exercise/FavExercise/:bankId/:typeId',
      name: 'FavExercise',
      meta: {
        title: "习题收藏",
        requireAuth: true
      },
      component: FavExercise
    },
    {
      path: '/exercise/CourseWare/:cid',
      name: 'CourseWare',
      meta: {
        title: "课件资料",
        requireAuth: true
      },
      component: CourseWare
    },
    {
      path: '/exercise/CourseYati/:cid',
      name: 'CourseYati',
      meta: {
        title: "押题",
        requireAuth: true
      },
      component: CourseYati
    }
  ]
})

router.afterEach((to, from) => {
  // 登录判断
  let needLoginPage = [
    'Member',
    'Collect',
    'Question',
    'Study',
    'Paper',
    'WrongBook',
    'FavExercise',
    'CourseWare',
    'CourseYati'
  ];
  if (needLoginPage.indexOf(to.name) != -1) {
    Store.dispatch('isLogin');
  }
})



export default router;



// WEBPACK FOOTER //
// ./src/router/index.js